import React, { useEffect, useState, useCallback } from 'react';

import { ButtonWithSpinner } from '@eika/button-with-spinner';

import { StickyFooterRow } from '../../../../../../components/shared/StickyFooter';
import useTranslation from '../../../../../../hooks/useTranslation';
import { useDndContext } from '../GroupedSortableDnd';
import { groupStatesAreNotEqual } from './utils';

import './ActionButtons.scss';

type ActionButtonsProps = {
    isLoading: boolean;
};

export const ActionButtons: React.FC<ActionButtonsProps> = ({ isLoading }) => {
    const translated = useTranslation();

    const {
        lastSaved: [lastSaved],
        grouped: [groupedAccounts, setGroupedAccounts],
        viewMode: [viewMode, setViewMode],
        editedHeader: [editedHeader, setEditedHeader],
        headerValue: [headerValue, setHeaderValue],
    } = useDndContext();

    const [showSaveButton, setShowSaveButton] = useState(false);

    const save = useCallback(() => {
        if (!headerValue || headerValue === '') {
            return;
        }
        const update = groupedAccounts.map((group) => {
            if (group.id === editedHeader) {
                return { ...group, name: headerValue };
            }
            return group;
        });
        setGroupedAccounts(update);
        setEditedHeader(undefined);
        setHeaderValue(undefined);
        setViewMode('display');
    }, [editedHeader, groupedAccounts, headerValue, setEditedHeader, setGroupedAccounts, setHeaderValue, setViewMode]);

    useEffect(() => {
        const hasChange = groupStatesAreNotEqual(lastSaved, groupedAccounts);
        if (showSaveButton !== hasChange) {
            setShowSaveButton(hasChange);
        }
    }, [groupedAccounts, lastSaved, showSaveButton]);

    return (
        <>
            {viewMode === 'edit' && (
                <StickyFooterRow>
                    <ButtonWithSpinner size="small" buttonType="positive" type="button" onClick={save}>
                        {translated.editAccounts.confirm}
                    </ButtonWithSpinner>
                </StickyFooterRow>
            )}
            {viewMode === 'display' && showSaveButton && (
                <StickyFooterRow>
                    <ButtonWithSpinner
                        className="action-buttons__confirm-button"
                        size="small"
                        buttonType="positive"
                        type="submit"
                        showSpinner={isLoading}
                    >
                        {translated.save}
                    </ButtonWithSpinner>
                </StickyFooterRow>
            )}
        </>
    );
};
